import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import ItineraryCancellation from "../components/itinerary/ItineraryCancellation";
import MobileHeader from "../components/MobileHeader";
import FloatingActionButton from "../components/home/FloatingActionButton";

const cancellationPolicy = [
  { period: "More than 60 days before departure", fees: "25% of total package cost" },
  { period: "30-60 days before departure", fees: "50% of total package cost" },
  { period: "15-29 days before departure", fees: "75% of total package cost" },
  { period: "Less than 15 days before departure", fees: "100% of total package cost" },
];

const Cancellation = () => (
  <>
    <div className="d-none d-lg-block">
      <Header />
    </div>
    <MobileHeader />
    <div className="container py-5">
      <div className="itinerary-container">
        <ItineraryCancellation cancellationPolicy={cancellationPolicy} />
      </div>
    </div>
    <FloatingActionButton />
    <Footer />
  </>
);

export default Cancellation;
